<div class="likes-avatar" *ngIf="likes.total_count > 0">
    <ion-avatar *ngFor="let avatar of avatars">
        <img src="{{avatar.avatar}}" alt="" />
    </ion-avatar>
    <div class="avatar-overlap" *ngIf="likes.total_count > max">...</div>
    <span class="liked">{{'social.posts.liked' | translate}}</span>
</div>